<template>
  <div class="max-w-7xl mx-auto sm:px-2 lg:px-8">
    <div class=" overflow-hidden">
      <CentralHeader
        title="UGM BUNDLE"
        class="mt-12"
        subtitle=""
      ></CentralHeader>
      <div class="mt-10">
        <Card class="bg-grey">
          <div
            class="mt-0 md:mt-6 lg:mt-6 p-4 flex flex-col space-y-6 md:space-y-0 justify-around
              lg:px-20
           "
          >
            <div class="mb-6">

              <p><img
                  class="block w-auto mx-auto mb-12"
                  src="/images/coming-soon-ugm.gif"
                  alt="Vectric UGM logo"
              /></p>

              <h4
                class="text-base md:text-xl leading-6 font-semibold text-gray-900 text-center mb-6"
              >
                Watch this space for a bigger and better User Group Meeting bundle than ever before...
              </h4>

             <!-- <div class="md:flex">
                <div class="flex sm:w-1/2 mx-6">
                  <ul>
                    <li
                      class="m-0 p-[0.25rem] pl-12 mb-4 bg-largeListTick bg-no-repeat bg-left-top items-center grid"
                    >
                      <span class="block font-normal h-auto bg-contain">Head To Head Sketch Carving<br class="block md:hidden">
                        <img
                            class="inline-block md:mt-0 mt-2 relative topminus mx-1 h-7 w-7 p-1 bg-aspire rounded-full"
                            src="/images/aspire-small.svg"
                            alt="Aspire"
                        />

                        <img
                            class="inline-block md:mt-0 mt-2 relative topminus mx-1 h-7 w-7 p-1 bg-vcarvePro rounded-full"
                            src="/images/vcarve_for_round.svg"
                            alt="VCarve Pro"
                        />

                        <img
                            class="inline-block md:mt-0 mt-2 relative topminus mx-1 h-7 w-7 p-1 bg-vcarveDesktop rounded-full"
                            src="/images/vcarve_for_round.svg"
                            alt="VCarve Desktop"
                        />
                      </span>
                    </li>
                    <li
                      class="m-0 p-[0.25rem] pl-12 mb-4 bg-largeListTick bg-no-repeat bg-left-top items-center grid"
                    >
                      <span class="block font-normal"
                        >Restoration Modeling<br class="block md:hidden">
                      <img
                          class="inline relative md:mt-0 mt-2 topminus mx-1 h-7 w-7 p-1 bg-aspire rounded-full"
                          src="/images/aspire-small.svg"
                          alt="Aspire"
                      /></span
                      >
                    </li>
                    <li
                      class="m-0 p-[0.25rem] pl-12 mb-4 bg-largeListTick bg-no-repeat bg-left-top items-center grid"
                    >
                      <span class="block font-normal"
                        >Tips & Tricks - Editing 3D Models<br class="block md:hidden">
                      <img
                          class="inline relative md:mt-0 mt-2 topminus mx-1 h-7 w-7 p-1 bg-aspire rounded-full"
                          src="/images/aspire-small.svg"
                          alt="Aspire"
                      />

                        <img
                            class="inline-block relative md:mt-0 mt-2 topminus mx-1 h-7 w-7 p-1 bg-vcarvePro rounded-full"
                            src="/images/vcarve_for_round.svg"
                            alt="VCarve Pro"
                        />

                        <img
                            class="inline-block relative md:mt-0 mt-2 topminus mx-1 h-7 w-7 p-1 bg-vcarveDesktop rounded-full"
                            src="/images/vcarve_for_round.svg"
                            alt="VCarve Desktop"
                        /></span
                      >
                    </li>
                  </ul>
                </div>

                <div class="flex sm:w-1/2 mx-6">
                  <ul>
                    <li
                      class="m-0 p-[0.25rem] pl-12 mb-4 bg-largeListTick bg-no-repeat bg-left-top items-center grid"
                    >
                      <span class="block font-normal"
                        >Melodies To Memories<br class="block md:hidden">
                      <img
                          class="inline relative topminus md:mt-0 mt-2 mx-1 h-7 w-7 p-1 bg-aspire rounded-full"
                          src="/images/aspire-small.svg"
                          alt="Aspire"
                      />

                        <img
                            class="inline-block relative md:mt-0 mt-2 topminus mx-1 h-7 w-7 p-1 bg-vcarvePro rounded-full"
                            src="/images/vcarve_for_round.svg"
                            alt="VCarve Pro"
                        />
                        <img
                            class="inline-block relative md:mt-0 mt-2 topminus mx-1 h-7 w-7 p-1 bg-cut2dPro rounded-full"
                            src="/images/cut2dpro_for_round.svg"
                            alt="Cut2D Pro"
                        />
                      </span
                      >
                    </li>
                    <li
                      class="m-0 p-[0.25rem] pl-12 mb-4 bg-largeListTick bg-no-repeat bg-left-top items-center grid"
                    >
                      <span class="block font-normal"
                        >Revelations Of Rotary from Sienci Labs<br class="block md:hidden">
                        <img
                          class="inline relative topminus md:mt-0 mt-2 mx-1 h-7 w-7 p-1 bg-aspire rounded-full"
                          src="/images/aspire-small.svg"
                          alt="Aspire"
                      />

                        <img
                            class="inline-block relative md:mt-0 mt-2 md:mt-0 mt-2 topminus mx-1 h-7 w-7 p-1 bg-vcarvePro rounded-full"
                            src="/images/vcarve_for_round.svg"
                            alt="VCarve Pro"
                        />

                        <img
                            class="inline-block relative topminus md:mt-0 mt-2 mx-1 h-7 w-7 p-1 bg-vcarveDesktop rounded-full"
                            src="/images/vcarve_for_round.svg"
                            alt="VCarve Desktop"
                        /></span
                      >
                    </li>
                  </ul>
                </div>
              </div>

              <div class="my-12">
                <img
                  src="/images/ugmbundlemainimg.png"
                  alt="UGM 2025 Bundle"
                  class=""
                />
              </div>

              <h4
                class="text-base md:text-xl leading-6 font-semibold text-gray-900 text-center mb-6"
              >
                Plus - Bonus PDFs of all guest presentations including:
              </h4>

              <div class="md:flex">
                <div class="flex sm:w-1/2 mx-6">
                  <ul>
                    <li
                      class="m-0 p-[0.25rem] pl-12 mb-4 bg-largeListTick bg-no-repeat bg-left-top items-center grid"
                    >
                      <span class="block font-normal"
                        >A18 train restoration</span
                      >
                    </li>
                    <li
                      class="m-0 p-[0.25rem] pl-12 mb-4 bg-largeListTick bg-no-repeat bg-left-top items-center grid"
                    >
                      <span class="block font-normal"
                        >Marketing your business</span
                      >
                    </li>
                    <li
                      class="m-0 p-[0.25rem] pl-12 mb-4 bg-largeListTick bg-no-repeat bg-left-top items-center grid"
                    >
                      <span class="block font-normal"
                        >Triumphs and pitfalls of AI</span
                      >
                    </li>
                    <li
                      class="m-0 p-[0.25rem] pl-12 mb-4 bg-largeListTick bg-no-repeat bg-left-top items-center grid"
                    >
                      <span class="block font-normal"
                        >Creating oversized sculptures</span
                      >
                    </li>
                  </ul>
                </div>

                <div class="flex sm:w-1/2 mx-6">
                  <ul>
                    <li
                      class="m-0 p-[0.25rem] pl-12 mb-4 bg-largeListTick bg-no-repeat bg-left-top items-center grid"
                    >
                      <span class="block font-normal"
                        >Mastering the art of V-Carving</span
                      >
                    </li>
                    <li
                      class="m-0 p-[0.25rem] pl-12 mb-4 bg-largeListTick bg-no-repeat bg-left-top items-center grid"
                    >
                      <span class="block font-normal">Software efficiency</span>
                    </li>
                    <li
                      class="m-0 p-[0.25rem] pl-12 mb-4 bg-largeListTick bg-no-repeat bg-left-top items-center grid"
                    >
                      <span class="block font-normal"
                        >Taking your carvings to the next level</span
                      >
                    </li>
                  </ul>
                </div>
              </div>

              <div class="my-6">
                <img
                  src="/images/ProductIconsLine.png"
                  alt="Product Icons"
                  class="lg:w-5/12 md:w-1/2 sm:w-3/4 px-6 mx-auto"
                />
              </div>

              <h4
                class="text-base md:text-xl leading-6 font-semibold text-gray-900 text-center mb-6"
              >
                Purchase the 2024 UGM bundle for $49
              </h4>

              <button
                data-fsc-item-path-value="vectric-user-group-bundle-2024"
                data-fsc-action="Add, Checkout"
                class="px-10 mx-auto block mb-12 sm:w-1/2 md:w-1/3 w-auto py-5 border text-center border-transparent bg-vectric rounded-md text-darkFont font-bold transition duration-150 ease-in-out"
              >
                PURCHASE BUNDLE
              </button> -->
            </div>
          </div>
        </Card>
      </div>
    </div>
  </div>
</template>

<script lang="js">

import CentralHeader from "../components/shared/CentralHeader";
import Card from "../components/shared/Card.vue";

export default {
  name: "Purchase",
  components: {
    Card,
    CentralHeader
  },
  /*mounted() {
    this.initializeFS();
  },
  methods: {
    initializeFS() {
      let customerDetails = {
        "reset": true,
        "tags": {
          route: "onlineUserGroupMeeting"
        }
      };

      // eslint-disable-next-line no-undef
      fastspring.builder.push(customerDetails);
    },
  }*/
};
</script>

<style scoped>
.container-gradient {
  background-image: linear-gradient(
    160deg,
    theme("colors.white"),
    theme("colors.lighterblue")
  );
}

.venue {
  top: -12px;
}

.bg-grey {
  background: #ededed;
}

.bg-largeListTick {
  background-image: url("../assets/tick-yellow-black.svg");
  background-size: 24px 24px;
}

.topminus {
  top: -2px;
}
</style>
